module.exports = __webpack_public_path__ + "img/Sreekumar_Gopakumar_Pillai.422aceae.jpeg";